import DistanceCell from './container';

export default DistanceCell;
